import { WHY_SBC, LIFESTYLE } from "@/data/products";
import { Check } from "lucide-react";

export default function WhyChooseSBC() {
  return (
    <section className="py-24 lg:py-32 bg-muted/40" data-testid="why-sbc-section">
      <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-5 space-y-6">
          <div className="eyebrow">Why Choose SBC</div>
          <h2 className="font-display font-bold text-4xl lg:text-5xl tracking-tighter leading-tight">
            The trusted partner for <span className="gold-gradient-text">modern beverage retail.</span>
          </h2>
          <p className="text-muted-foreground leading-relaxed">
            Whether you&rsquo;re a distributor, retailer, hospitality group or government buyer, SBC delivers world-class quality with reliability you can plan around.
          </p>
          <img src={LIFESTYLE.warehouse} alt="Warehouse" className="rounded-2xl w-full aspect-video object-cover shadow-lg" />
        </div>
        <div className="lg:col-span-7 grid sm:grid-cols-2 gap-3">
          {WHY_SBC.map((w, i) => (
            <div key={w.title} className="p-5 rounded-2xl bg-background border border-border hover:border-gold-400 transition-colors">
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 rounded-full bg-gold-400/15 flex items-center justify-center flex-shrink-0">
                  <Check className="w-4 h-4 text-gold-500" />
                </div>
                <div>
                  <div className="font-display font-semibold text-base">{w.title}</div>
                  <p className="text-xs text-muted-foreground mt-1.5 leading-relaxed">{w.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
